
import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Paper,
  Box,
  Typography,
} from "@mui/material";
import { approvalhistory } from "./api";
import { getToken } from "../../utils/utils";



interface RowData {
  id: number;
  requested_on: string;
  banner_images: string;
  status: string;
  brands_banner_approved_by: string;
}
interface BannerTableProps {
  refreshKey: number;
  brandapprovalhistory: RowData[]
}

const BannerTable: React.FC<BannerTableProps> = ({ refreshKey, brandapprovalhistory }) => {
  console.log(refreshKey, "refreshKeyrefreshKeyrefreshKey")
  console.log(brandapprovalhistory, "brandapprovalhistoryssssss")
  const [rows, setRows] = useState<RowData[]>([]);
  const [order, setOrder] = useState<"asc" | "desc">("asc");
  const [orderBy, setOrderBy] = useState<keyof RowData | "">("");
  const [loading, setLoading] = useState<boolean>(true);
  const handleSort = (property: keyof RowData) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  // const fetchApprovalHistory = async () => {
  //   try {
  //     const token = getToken();
  //     const response = await approvalhistory({}, token);
  //     const data = response.data.data;

  //     const mappedData = data.map((item: any) => ({
  //       id: item.id,
  //       requestedOn: new Date(item.request_on).toLocaleDateString(),
  //       brandImage: item.banner_images,
  //       status: item.status,
  //       approved: item.approved_by || "N/A",
  //     }));
  //     setRows(mappedData);
  //   } catch (error) {
  //     console.error("Error fetching approval history:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchApprovalHistory();
  // }, [refreshKey]); // Re-fetch when refreshKey changes



  return (
    <Box>
      <Typography
        variant="h3"
        sx={{
          fontSize: "18px",
          color: "#282829",
          fontWeight: "600",
          padding: "20px",
          background: "#fff",
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
        }}
      >
        Approval History
      </Typography>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="sortable table">
          <TableHead sx={{ background: "#EEF4FF" }}>
            <TableRow>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "id"}
                  direction={orderBy === "id" ? order : "asc"}
                  onClick={() => handleSort("id")}
                  sx={{ "& .MuiTableSortLabel-icon": { opacity: 1 } }}
                >
                  S.No
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "requested_on"}
                  direction={orderBy === "requested_on" ? order : "asc"}
                  onClick={() => handleSort("requested_on")}
                  sx={{ "& .MuiTableSortLabel-icon": { opacity: 1 } }}
                >
                  Requested on
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "banner_images"}
                  direction={orderBy === "banner_images" ? order : "asc"}
                  onClick={() => handleSort("banner_images")}
                  sx={{ "& .MuiTableSortLabel-icon": { opacity: 1 } }}
                >
                  Images
                </TableSortLabel>

              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "status"}
                  direction={orderBy === "status" ? order : "asc"}
                  onClick={() => handleSort("status")}
                  sx={{ "& .MuiTableSortLabel-icon": { opacity: 1 } }}
                >
                  Status
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "brands_banner_approved_by"}
                  direction={orderBy === "brands_banner_approved_by" ? order : "asc"}
                  onClick={() => handleSort("brands_banner_approved_by")}
                  sx={{ "& .MuiTableSortLabel-icon": { opacity: 1 } }}
                >
                  Approved by
                </TableSortLabel>

              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {brandapprovalhistory.map((row) => (

              <TableRow key={row.id}>
                <TableCell>{row.id}</TableCell>
                <TableCell>{row.requested_on}</TableCell>
                <TableCell>{row.banner_images}</TableCell>
                <TableCell>{row.status}</TableCell>
                <TableCell>{row.brands_banner_approved_by}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default BannerTable;
